module.exports = __webpack_public_path__ + "img/排插.49a03bd8.png";